module.exports = __webpack_public_path__ + "assets/chevron-left-sharp.af2e384e.svg";